import api from './api';

const logService = {
  getAll: async () => {
    const response = await api.get('/logs');
    return response.data;
  }
};

export default logService;
